import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal, EmailModal } from 'src/modules/shared';
import { Location } from '@angular/common';
import { SharedValidators } from 'src/modules/shared';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { UserService } from '../../../services';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import {
  takeUntil,
  delay,
  debounceTime,
  distinctUntilChanged,
  tap,
  map,
  switchMap,
  catchError,
} from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CoreService } from 'src/modules/core/services';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  isCorrect: string = 'true';
  success: any;
  error: any;
  errorArray: any[] = [];
  pending: boolean;
  userObject: any;
  ownershipType: Array<any> = [];
  companyType: Array<any> = [];
  ownership: any;
  company: any;

  formSubmitAttempt: boolean;
  detailForm: FormGroup;
  companyTypes: Array<any> = [];
  companyAddress: boolean = false;
  mobileNumber: boolean = false;
  loginInfo: boolean = false;
  public countries: any;
  public states: any;
  public mode: string = 'date';
  public usernameLoading = false;
  public emailLoading = false;

  usernameError;
  usernameServerError;
  companyEmailLoading;
  companyEmailError;
  companyEmailServerError;
  emailError;
  emailServerError;

  //collapsers
  collapseCompanySection: boolean = false;

  selectedCountry = {
    class: 'com.bpp.ccsp.entities.models.Countries',
    countryCode: 'NG',
    countryName: 'Nigeria',
    unRegion: 'Africa',
    unSubregion: 'Western Africa',
  };
  oldDetails;
  captcha;
  siteKey = environment.siteKey;
  source;
  token: string | null;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private userSvc: UserService,
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private coreSvc: CoreService
  ) {
    this.detailForm = this.fb.group(
      {
        ownershipType: [null],
        actualCompanyType: [null],
        headOfficeAddressCity: [null, [Validators.required]],
        headOfficeAddressPobox: [null],
        headOfficeAddressPmb: [null],
        headOfficeAddressZip: [null],
        headOfficeAddressState: [null, [Validators.required]],
        countryOfRegistration: [
          this.selectedCountry.countryCode,
          [Validators.required],
        ],
        headOfficeAddressStreet: [null, [Validators.required]],
        companyContactEmail: [
          '',
          [Validators.required, SharedValidators.email],
        ],
        companyContactAlternativeEmail: [null],
        companyName: [null],
        companyContactPhone1: [null],
        companyContactPhone2: [null],
        dateOfRegistration: [null, [Validators.required]],
        appUserEmail: ['', [Validators.required, SharedValidators.email]],
        tinNumber: [null],
        rcNumber: [null],
        website: [null],
        username: [null, [Validators.required]],
        password: [null, [Validators.required, Validators.minLength(6)]],
        confirmPassword: [null, [Validators.required, Validators.minLength(6)]],
        captcha: [null, [Validators.required]],
        source: ['eservices'],
        iRRNumber: [null],
      },
      {
        validator: SharedValidators.matchingPasswords(
          'password',
          'confirmPassword'
        ),
      }
    );
    this.activatedRoute.queryParams.subscribe((params) => {
      this.source = params['source'];
      this.token = params['token'];
    });
    this.userObject = JSON.parse(window.localStorage.getItem('userObject'));
    let option = JSON.parse(window.localStorage.getItem('options'));
    this.ownershipType = option['ownershipType'];
    this.companyType = option['companyType'];
    this.ownership = this.ownershipType.filter(
      (res) => res.optionId === this.userObject.ownership_type
    )[0];
    this.company = this.companyType.filter(
      (res) => res.optionId === this.userObject.company_type
    )[0];
    if (this.userObject.cacRecord) {
      this.detailForm.patchValue({
        // headOfficeAddressStreet: this.userObject.cacRecord['address'],
        companyName: this.userObject.cacRecord['companyName'],
      });
      this.detailForm.patchValue(this.userObject.cacRecord);
    } else {
      this.detailForm.patchValue({
        // headOfficeAddressStreet: this.userObject.cacRecord['address'],
        companyName: this.userObject.companyName,
      });
      this.detailForm.patchValue(this.userObject);
    }
    // this.detailForm.get("appUserEmail").errors

    this.detailForm
      .get('appUserEmail')
      .valueChanges.pipe(
        tap((res) => {
          this.emailLoading = true;
          this.emailError = false;
          this.emailServerError = false;
        }),
        delay(800),
        debounceTime(800),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.http
          .get(
            `${environment.API_SERVER}/auth/email-availablity/${value.trim()}/`
          )
          .subscribe(
            (res) => {
              this.emailLoading = false;
              if (res['status'] === true) {
                this.emailError = false;
              } else {
                this.emailError = true;
              }
            },
            (error) => {
              this.emailLoading = false;
              if (error['status'] !== 404) {
                this.emailServerError = false;
              } else {
                this.emailServerError = true;
              }
            }
          );
      });
    this.detailForm
      .get('companyContactEmail')
      .valueChanges.pipe(
        tap((res) => {
          this.companyEmailLoading = true;
          this.companyEmailError = false;
          this.companyEmailServerError = false;
        }),
        delay(800),
        debounceTime(800),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.companyEmailLoading = true;
        this.companyEmailError = false;
        this.companyEmailServerError = false;
        this.http
          .get(
            `${
              environment.API_SERVER
            }/auth/company-email-availablity/${value.trim()}/`
          )
          .subscribe(
            (res) => {
              this.companyEmailLoading = false;
              if (res['status'] === true) {
                this.companyEmailError = false;
              } else {
                this.companyEmailError = true;
              }
            },
            (error) => {
              console.log(error);
              this.companyEmailLoading = false;
              if (error['status'] !== 404) {
                this.companyEmailServerError = false;
              } else {
                this.companyEmailServerError = true;
              }
            }
          );
      });
    this.detailForm
      .get('username')
      .valueChanges.pipe(
        tap((res) => {
          this.usernameLoading = true;
          this.usernameError = false;
          this.usernameServerError = false;
        }),
        delay(800),
        debounceTime(800),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.usernameLoading = true;
        this.usernameError = false;
        this.usernameServerError = false;
        this.http
          .get(`${environment.API_SERVER}/auth/username_availability/${value}/`)
          .subscribe(
            (res) => {
              this.usernameLoading = false;
              if (res['status'] === true) {
                this.usernameError = false;
              } else {
                this.usernameError = true;
              }
            },
            (error) => {
              console.log(error);
              this.usernameLoading = false;
              if (error['status'] !== 404) {
                this.usernameServerError = false;
              } else {
                this.usernameServerError = true;
              }
            }
          );
      });
    this.getCountry();
    this.getState();
  }
  resolved(e) {
    console.log(e);
  }
  errored(e) {
    console.log(e);
  }
  getCountry() {
    this.coreSvc.getCountries({}).subscribe((res) => {
      this.countries = res['rows'];
    });
  }
  getState() {
    this.coreSvc.getStates({}).subscribe((res) => {
      this.states = res['rows'];
    });
  }
  isFieldValid(field: string) {
    field = field.trim();
    return (
      (!this.detailForm.get(field).valid &&
        this.detailForm.get(field).touched) ||
      (this.detailForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field.trim()),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field.trim(),
    };
  }
  convertToUTC(originalDateString: string): string {
    const originalDate = new Date(originalDateString);

    // Adjust the time zone offset
    originalDate.setHours(originalDate.getHours() + 1);

    // Format the date in UTC using Intl.DateTimeFormat
    const formattedDate = originalDate.toISOString();

    return formattedDate || ''; // Handle null or undefined cases
  }
  submit() {
    let rc_number;
    if (this.userObject.rc_number) {
      rc_number = this.userObject.rc_number;
    } else {
      rc_number = this.userObject.registrationNumber;
    }
    this.formSubmitAttempt = false;
    if (this.detailForm.value.username.length > 32) {
      this.error =
        'Username is too long . Username characters should be less than 32';
      this.goTop();
      return;
    }
    if (this.detailForm.value.appUserEmail.length > 128) {
      this.error =
        'Email is too long . Email characters should be less than 128';
      this.goTop();
      return;
    }
    if (
      // this.detailForm.valid &&
      this.detailForm.value.appUserEmail.length < 128 &&
      this.detailForm.value.username.length < 32
    ) {
      this.pending = true;
      this.detailForm.value.ownershipType = this.userObject.ownership_type;
      this.detailForm.value.actualCompanyType = this.userObject.company_type;
      this.detailForm.value.rcNumber = rc_number;
      this.detailForm.value.username = this.detailForm.value.username.trim();
      this.detailForm.value.tinNumber = this.userObject.tin_number || null;
      this.detailForm.value.companyContactEmail =
        this.detailForm.value.companyContactEmail.trim();
      this.detailForm.value.appUserEmail =
        this.detailForm.value.appUserEmail.trim();

      this.detailForm.value.dateOfRegistration = this.convertToUTC(
        this.detailForm.value.dateOfRegistration
      );
      this.detailForm.value.validationKey = this.userObject['validationKey'];
      let sourceDataObject;
      const loginObject = JSON.parse(
        window.localStorage.getItem('loginObject')
      );
      if (
        loginObject &&
        loginObject?.length > 0 &&
        this.source === 'procurement'
      ) {
        sourceDataObject = {
          source: 'procurement',
          sourceData: `lotIds=${loginObject
            .map((item) => `${item.lotId},${item.biddingStageId}`)
            .join(';')}&rcNumber=${this.detailForm.value.rcNumber}`,
        };
        console.log(sourceDataObject, 'sourceDataObject');
      } else if (this.source === 'procurement') {
        sourceDataObject = {
          source: 'procurement',
        };
        console.log(sourceDataObject, 'newsourceDataObject');
      } else {
        sourceDataObject = {
          source: 'eservices',
          sourceData: '',
        };
      }
      const updatedValue = {
        ...this.detailForm.value,
        ...sourceDataObject,
      };
      this.userSvc
        .register({
          body:
            sourceDataObject.sourceData || sourceDataObject.source
              ? this.cleanObject(updatedValue)
              : this.cleanObject(this.detailForm.value),
        })
        .subscribe(
          (res: any) => {
            this.goTop();
            this.pending = false;
            this.success = 'Signup successful';
            const returnUrl = encodeURIComponent(res['returnUrl']);
            setTimeout(() => {
              if (this.source === 'procurement') {
                // this.router.navigate([returnUrl]);
                window.location.replace(res['returnUrl']);
              } else {
                this.router.navigateByUrl(res['returnUrl'].split('#')[1]);
              }
            }, 2000);
          },
          (error) => {
            console.log(error, 'error');
            if (error && error.error) {
              if (error.error instanceof Array) {
                this.errorArray = error.error;
              } else {
                switch (error.error['status']) {
                  case 400:
                    this.error = error.error['userMessage']
                      ? error.error['userMessage']
                      : error.error['developerMessage'];
                    break;
                  default:
                    this.error = error.error.errorMessage
                      ? error.error.errorMessage
                      : error.error
                      ? error.error
                      : error;
                    break;
                }
              }
            }
            this.goTop();
            this.pending = false;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  private cleanObject(obj: { [key: string]: any }): { [key: string]: any } {
    const result: { [key: string]: any } = {};

    for (const [key, value] of Object.entries(obj)) {
      if (value === '') {
        continue;
      }
      if (
        value !== null &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        const nested = this.cleanObject(value);
        if (Object.keys(nested).length) {
          result[key] = nested;
        }
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  goTop() {
    const elmnt = document.getElementById('top');
    elmnt.scrollIntoView({ behavior: 'smooth' });
  }

  deleteLot() {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Award?',
          'Are you sure you want to delete selected Award?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  goBack() {
    this.location.back();
  }
}
